/**
 *  数据字典过滤器
 * @param {*} code 数据编码
 * @param {*} dicData 数据编码相对应字典类型集合
 */
let sysDicFilter = (code,dicData) => {
    let dicName = code;
    for (let key in dicData) {
      if (dicData[key].value == code) {
        dicName = dicData[key].text
      }
    }
    return dicName
  }
  /**
   *
   * @param {*} value
   */
  let jsonFilter = (value) => {
    if (value == null) {
      return "";
    }
    let data = JSON.parse(value)
    return data.name
  }
  /**
   * @param {*} value  格式 201904250000 --- 2019-04-25
   */
  let dateFilter = (value) => {
    if (value == null) {
      return "";
    }
    let data = value.toString()
    return data.substring(0, 4) + '-' + data.substring(4, 6) + '-' + data.substring(6, 8)
  }
  /**
   *
   * @param {*} value   格式 20190425124512 --- 2019-04-25 12:45:12
   */
  let dateTimeFilter = (value) => {
    if (value == null) {
      return "";
    }
    let data = value.toString()
    return data.substring(0, 4) + '-' + data.substring(4, 6) + '-' + data.substring(6, 8) + ' ' + data.substring(8, 10) + ':' + data.substring(10, 12) + ':' + data.substring(12, 14)
  }
  /**
   * 下拉框 根据ID 获取名称
   * @param {*} value 值或者逗号隔开的  1,2,3
   * @param {*} data  下拉框中数据
   * @param {*} field 显示字段
   */
  let selectDisplayValue = (value,data,field) => {
    let name = ''
    if (value) {
      value = value + ''
      let valueArr = value.split(',')
      let arrLength = valueArr.length
      let dataLength = data.length
      for (let i = 0;i < arrLength;i++) {
        for (let k = 0;k < dataLength;k++) {
          if (data[k].id === valueArr[i]) {
            if (i === arrLength - 1) {
              name += data[k][field]
            } else {
              name += data[k][field] + ','
            }
          }
        }
      }
    }
    return name
  }
  
  /**
   * 下拉框 根据ID 获取名称
   * @param {*} value 没有用
   * @param {*} data  下拉框中数据
   * @param {*} field 显示字段  [id,字段值]
   */
  let selectDisplayParamValue = (value,data,field) => {
    let name = ''
    let dataLength = data.length
    for (let k = 0;k < dataLength;k++) {
      if (data[k].id === field[0]) {
        name = data[k][field[1]]
      }
    }
    return name
  }
  // 乘法
  let calcTimes = (value,arg1,arg2) => {
    let m = 0
    let s1 = arg1 == null ? '0' : arg1.toString()
    let s2 = arg2 == null ? '0' : arg2.toString()
    try {
      m += s1.split('.')[1].length
    } catch (e) {
      console.error(e)
    }
    try {
      m += s2.split('.')[1].length
    } catch (e) {
      console.error(e)
    }
    return Number(s1.replace('.','')) * Number(s2.replace('.','')) / Math.pow(10,m)
  }
  
  // 乘法
  let calcMoreTimes = (value,row,params) => {
    let num = row[params[0]]
    let price = row[params[1]]
    let col = row[params[2]]
    if (/^[0-9]+(.[0-9]{1,5})?$/.test(col)) {
      let monery = calcTimes(0,num,price)
      let amount = calcTimes(0,col,monery)
      return amount
    }
    return ''
  }
  
  // 加法
  let calcPlus = (arg1,arg2) => {
    let r1
    let r2
    let m
    try {
      r1 = arg1.toString().split('.')[1].length
    } catch (e) {
      r1 = 0
    }
    try {
      r2 = arg2.toString().split('.')[1].length
    } catch (e) {
      r2 = 0
    }
    m = Math.pow(10,Math.max(r1,r2))
    return(arg1 * m + arg2 * m) / m
  }
  
  // 字符串过长 用.... 代替
  let charSubString = (value,length) => {
    if (!length) {
      length = 15
    }
    if (value && value.length > length) {  // 字符最大长度
      value = value.substring(0,(length - 2)) + '...'   // 超过省略
    }
    return value
  }
  
  // 拼接字段  namg+code
  let joinFilter = (value,item,spacer) => {
    if (item === null || item === '' || item === undefined) {
      return value
    } else {
      return value + spacer + item
    }
  }
  // 起讫里程
  let joinListFilter = (value,data,join) => {
    let name = ''
    let dataLength = data.length
    for (let k = 0;k < dataLength;k++) {
      if (data[k].id === value) {
        let arr = join.split(',')
        name = data[k][arr[0]]
        if (data[k][arr[1]] == null) {
          name = data[k][arr[0]]
        } else {
          name = data[k][arr[0]] + '~' + data[k][arr[1]]
        }
      }
    }
    return name
  }
  export function currency (value, currency, decimals) {
    const digitsRE = /(\d{3})(?=\d)/g
    value = parseFloat(value)
    if (!isFinite(value) || (!value && value !== 0)) return ''
    currency = currency != null ? currency : ''
    decimals = decimals != null ? decimals : 2
    let stringified = Math.abs(value).toFixed(decimals)
    let _int = decimals
      ? stringified.slice(0, -1 - decimals)
      : stringified
    let i = _int.length % 3
    let head = i > 0
      ? (_int.slice(0, i) + (_int.length > 3 ? ',' : ''))
      : ''
    let _float = decimals
      ? stringified.slice(-1 - decimals)
      : ''
    let sign = value < 0 ? '-' : ''
    return sign + currency + head +
      _int.slice(i).replace(digitsRE, '$1,') +
      _float
  }
  
  export function formatTimeStemp (timeStamp) {
    timeStamp = Number(timeStamp)
    let year = new Date(timeStamp).getFullYear()
    let month = new Date(timeStamp).getMonth() + 1 < 10 ? '0' + (new Date(timeStamp).getMonth() + 1) : new Date(timeStamp).getMonth() + 1
    let date = new Date(timeStamp).getDate() < 10 ? '0' + new Date(timeStamp).getDate() : new Date(timeStamp).getDate()
    let hh = new Date(timeStamp).getHours() < 10 ? '0' + new Date(timeStamp).getHours() : new Date(timeStamp).getHours()
    let mm = new Date(timeStamp).getMinutes() < 10 ? '0' + new Date(timeStamp).getMinutes() : new Date(timeStamp).getMinutes()
    let ss = new Date(timeStamp).getSeconds() < 10 ? '0' + new Date(timeStamp).getSeconds() : new Date(timeStamp).getSeconds()
    let nowTime = year + '-' + month + '-' + date + ' ' + hh + ':' + mm + ':' + ss
    return nowTime
  }
  /**
   * 时间戳转时间 yyyy月MM年dd日
   * @param {时间戳} dateStr
   */
  export function formatData (dateStr) {
    dateStr = Number(dateStr)
    let year = new Date(dateStr).getFullYear()
    let month = new Date(dateStr).getMonth() + 1 < 10 ? '0' + (new Date(dateStr).getMonth() + 1) : new Date(dateStr).getMonth() + 1
    let date = new Date(dateStr).getDate() < 10 ? '0' + new Date(dateStr).getDate() : new Date(dateStr).getDate()
    let nowTime = year + '-' + month + '-' + date
    return nowTime
  }

  // 导出在一个对象上
  export const FilterHelper = {
    sysDicFilter,dateFilter,dateTimeFilter,selectDisplayValue,jsonFilter,
    charSubString,joinFilter,selectDisplayParamValue,joinListFilter,
    calcTimes,calcMoreTimes,calcPlus,currency,formatTimeStemp,formatData
  }
  